// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".service-select {\n  width: 215px;\n}\n.service-select .ctx-dropdown-label {\n  font-size: 0.75rem;\n}\n.service-select .std--dropdown .std--dropdown-list .v-list-item {\n  padding: 0px 12px;\n}", ""]);
// Exports
module.exports = exports;
